'use client';

import { useEffect } from 'react';

export default function TrustIndexWidget() {
    useEffect(() => {
        const container = document.getElementById('trustindex-widget');
        if (!container || container.querySelector('script')) return;

        const script = document.createElement('script');
        script.src = 'https://cdn.trustindex.io/loader.js?a17522464e74881e7a76ecb7461';
        script.async = true;
        container.appendChild(script);
    }, []);

    return <div id="trustindex-widget" className="px-4" />;
}
